export default function initCF7() {
  // Funksjon for å hente gclid fra URL
  function getGclid() {
    const urlParams = new URLSearchParams(window.location.search);
    const gclid = urlParams.get('gclid') || '';
    if (gclid) {
      console.log('gclid funnet i URL:', gclid);
    } else {
      console.log('Ingen gclid funnet i URL');
    }
    return gclid;
  }

  function setupCF7Listeners() {
    const forms = document.querySelectorAll('.wpcf7-form, .wpcf7-f6708');
    if (forms.length === 0) {
      console.warn('No CF7 forms found');
      return;
    }

    // Map to store original display styles of hidden elements
    const originalDisplayStyles = new Map();

    forms.forEach(function (formElement) {
      // Sjekk om skjemaet allerede er behandlet
      if (formElement.dataset.cf7ListenerAdded) {
        console.log('Skjema allerede behandlet, hopper over:', formElement.id || 'unknown');
        return;
      }

      // Marker skjemaet som behandlet
      formElement.dataset.cf7ListenerAdded = 'true';

      // Set the page URL in the hidden field (new functionality)
      const hiddenField = formElement.querySelector('input[name="page_url"]');
      if (hiddenField) {
        hiddenField.value = window.location.href; // Set the current page URL
      } else {
        console.warn('Hidden field "page_url" not found in form');
      }

      // Handle submit button click
      const submitButton = formElement.querySelector('.wpcf7-submit');
      if (submitButton) {
        submitButton.addEventListener('click', function () {
          const formWrapper = formElement.querySelector('.form-wrapper');
          if (formWrapper) {
            formWrapper.style.display = 'none';
          } else {
            console.warn('Form wrapper (.form-wrapper) not found');
          }
          const parent = formElement.closest('.unifon-kontaktskjema-shortcode') || formElement.parentElement || document;
          const loader = parent.querySelector('.js-loader-step');
          if (loader) {
            loader.classList.remove('hidden');
          } else {
            console.warn('Loader (.js-loader-step) not found in parent:', parent);
          }

          // Hide all elements with hide-on-form-submission class
          const hideElements = document.querySelectorAll('.hide-on-form-submission');
          hideElements.forEach(element => {
            if (!element.classList.contains('js-loader-step') && !element.classList.contains('js-third-step')) {
              const computedStyle = window.getComputedStyle(element).display;
              originalDisplayStyles.set(element, computedStyle);
              element.style.display = 'none';
            }
          });
        }, false);
      } else {
        console.warn('Submit button (.wpcf7-submit) not found in form');
      }

      // Handle clicks on <p> elements to focus inputs
      const formWrapper = formElement.querySelector('.form-wrapper');
      if (formWrapper) {
        const pElements = formWrapper.querySelectorAll('p');
        pElements.forEach(function (pElement) {
          pElement.addEventListener('click', function (event) {
            if (event.target.tagName === 'INPUT' || event.target.tagName === 'TEXTAREA') {
              return;
            }
            const input = pElement.querySelector('input:not([type="submit"]):not([type="checkbox"]), textarea');
            if (input) {
              input.focus();
            }
          }, false);
        });
      } else {
        console.warn('Form wrapper (.form-wrapper) not found for input focus');
      }

      formElement.addEventListener('wpcf7submit', function (event) {
        console.log('wpcf7submit fired');
      }, false);

      // Handle successful form submission and push to Data Layer
      formElement.addEventListener('wpcf7mailsent', function (event) {
        console.log('wpcf7mailsent fired - Ny kode for Data Layer kjører nå');

        // Hent gclid og bestem trafikkilde
        const gclid = getGclid();
        const trafficSource = gclid ? 'google_ads' : 'organic';

        // Forbered data som skal pushes til Data Layer
        const dataLayerPayload = {
          'event': 'nyFormSubmission',
          'formId': formElement.id || 'unknown',
          'formClasses': formElement.className || '',
          'formAction': formElement.action || '',
          'gclid': gclid,
          'trafficSource': trafficSource
        };

        // Logg dataene som blir sendt til Data Layer
        console.log('Data Layer push utført med følgende data:', dataLayerPayload);

        // Push til Data Layer
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(dataLayerPayload);

        const parent = formElement.closest('.unifon-kontaktskjema-shortcode') || formElement.parentElement || document;
        const loader = parent.querySelector('.js-loader-step');
        if (loader) {
          loader.classList.add('hidden');
        }
        const finito = parent.querySelector('.js-third-step');
        if (finito) {
          finito.classList.remove('hidden');
        } else {
          console.warn('Finito (.js-third-step) not found in parent:', parent);
        }
      }, false);

      // Handle failure cases to restore hidden elements
      const handleFailure = function (event) {
        console.log(`${event.type} fired`);
        const formWrapper = formElement.querySelector('.form-wrapper');
        if (formWrapper) {
          formWrapper.style.display = 'block';
        } else {
          console.warn('Form wrapper (.form-wrapper) not found');
        }
        const parent = formElement.closest('.unifon-kontaktskjema-shortcode') || formElement.parentElement || document;
        const loader = parent.querySelector('.js-loader-step');
        if (loader) {
          loader.classList.add('hidden');
        }
        // Restore hidden elements with hide-on-form-submission class
        originalDisplayStyles.forEach((display, element) => {
          element.style.display = display || 'block';
        });
        originalDisplayStyles.clear(); // Clear stored styles
      };

      formElement.addEventListener('wpcf7invalid', handleFailure, false);
      formElement.addEventListener('wpcf7spam', handleFailure, false);
      formElement.addEventListener('wpcf7mailfailed', handleFailure, false);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupCF7Listeners);
  } else {
    setupCF7Listeners();
  }

  const observer = new MutationObserver(function (mutations, obs) {
    const forms = document.querySelectorAll('.wpcf7-form:not([data-cf7-listener-added])');
    if (forms.length > 0) {
      console.log('MutationObserver fant nye ubehandlede skjemaer:', forms.length);
      setupCF7Listeners();
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });
}